import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ColumnType, TableHeader } from '../../components/Table'
import {
  getInvitedUsersPageSize,
  getProfileManagementFilters,
  InvitedUser,
  ProfileManagementActions
} from '../../redux/account/profile-management'
import { useTableColumnVisibility } from '../../redux/table/hooks'
import { createTFunction } from '../../utils/helpers'

export type ProfileManagementTableHeaderProps = {
  tableColumns: ColumnType<InvitedUser>[]
}

export const ProfileManagementTableHeader = ({ tableColumns }: ProfileManagementTableHeaderProps) => {
  const { t } = useTranslation(['form', 'account'])
  const tt = createTFunction('account:ProfileManagement.', t)
  const dispatch = useDispatch()

  const columnSelection = useTableColumnVisibility('profileManagement')
  const filters = useSelector(getProfileManagementFilters)
  const pageSize = useSelector(getInvitedUsersPageSize)

  return (
    <TableHeader
      advancedFilterDialog="ProfileManagementAdvancedFilter"
      columnSelectorProps={{ columns: tableColumns, ...columnSelection }}
      isAdvancedFilterActive={_.some(_.keys(filters))}
      onSearchSubmit={values => {
        dispatch(ProfileManagementActions.setSearchFilter(values.query))
        dispatch(
          ProfileManagementActions.loadInvitedUsers({
            page: 1,
            pageSize
          })
        )
      }}
      searchLabel={t('form:Search')}
      searchName="query"
      searchPlaceholder={tt('InsertUserEmail')}
    />
  )
}
